import React from 'react';
export function Footer() {
  return <footer className="pt-12 md:pt-16 pb-6 px-5 md:px-12 lg:px-24" style={{
    backgroundColor: '#0F0E0D'
  }} data-id="element-14">
      <div className="max-w-7xl mx-auto" data-id="element-15">
        {/* Main footer content */}
        <div className="flex justify-center md:justify-start pb-8 md:pb-10" data-id="element-16">
          {/* Agency logo placeholder */}
          <div className="w-[120px] h-[42px] md:w-[140px] md:h-[48px] border border-brand-grey/30 flex items-center justify-center" data-id="element-17">
            <span className="font-mono text-[9px] md:text-[10px] text-brand-grey/50 uppercase tracking-label" data-id="element-18">
              Agency Logo
            </span>
          </div>
        </div>

        {/* Gold rule */}
        <div className="border-t border-brand-gold" style={{
        borderTopWidth: '1px'
      }} data-id="element-19" />

        {/* Below-rule lines */}
        <div className="pt-4 md:pt-5 text-center flex flex-col gap-2" data-id="element-20">
          <p className="font-mono px-2" style={{
          fontSize: '8px',
          color: '#9A9590',
          letterSpacing: '0.3em',
          lineHeight: '1.6'
        }} data-id="element-21">
            This property is being offered for sale prior to public listing. All
            enquiries are strictly confidential. Prepared exclusively for
            registered buyers.
          </p>
          <p className="font-mono uppercase" style={{
          fontSize: '8px',
          color: '#9A9590',
          letterSpacing: '0.3em'
        }} data-id="element-22">
            Digitally crafted by VAULT[LAB] · vaultlab.agency
          </p>
        </div>
      </div>
    </footer>;
}